/**
 * Mutación que carga la información de identificacion de peligros a la salud.
 * 
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} identificacion contiene la información de identificación de peligros
 */
export function setIdentificacionPe(state, identificacion){
    state.selectedIdentificacionPe = identificacion;
}

/**
 * Mutación que limpiar la información de identificación de peligros a la salud.
 * 
 * @param {*} state contiene la información de variables del formulario.
 */
export function limpiarIdentificacionPe(state){
    state.selectedIdentificacionPe.id_producto = '',
    state.selectedIdentificacionPe.efecto_cronico ='',
    state.selectedIdentificacionPe.cancerigeno  = '',
    state.selectedIdentificacionPe.organos_ataca ='',
    state.selectedIdentificacionPe.cronicos_salud =''
}